import { useFetch } from "./useFetch.ts";
import { apiPrefix } from "../../utils/main.ts";

export function useAnnexData() {
  const { fetch: fetchAnnexes, data: annexData } =
    useFetch<ImdrfCodeWithOverrideDTO[]>();

  async function getAnnexesData(annexes: ImdrfAnnex[], projectId: string) {
    const annexIds = annexes.map((a) => a.id).join(",");

    await fetchAnnexes(
      `${apiPrefix}/imdrf/annexes/all?projectId=${projectId}&annexes=${annexIds}`,
      {
        postResponseAction: (data) => {
          for (const annex of annexes) {
            annex.children = data?.filter((imdrf) => {
              return imdrf.annex === annex.id;
            });
          }
          return annexes;
        },
      },
    );
    return annexData;
  }

  return {
    getAnnexesData,
  };
}
